import { render, staticRenderFns } from "./OkrConsultantsOverview.vue?vue&type=template&id=33338189&scoped=true"
import script from "./OkrConsultantsOverview.vue?vue&type=script&lang=js"
export * from "./OkrConsultantsOverview.vue?vue&type=script&lang=js"
import style0 from "./OkrConsultantsOverview.vue?vue&type=style&index=0&id=33338189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33338189",
  null
  
)

export default component.exports